export default __webpack_public_path__ + "static/media/warning--triple-lanes-right-turn--g1.c58a09f1.png";